import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Input, Box, Heading } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

const ModifyCategory = () => {
  const { id } = useParams();
  const [categoryName, setCategoryName] = useState('');

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories/${id}`);
        setCategoryName(response.data.categoryName);
      } catch (error) {
        console.error('Error fetching category:', error);
      }
    };

    fetchCategory();
  }, [id]);

  const handleSaveCategory = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/categories/${id}`, { categoryName });
      alert('Category modified successfully');
    } catch (error) {
      console.error('Error modifying category:', error);
    }
  };

  return (
    <Box p={8}>
      <Heading mb={6}>Modify Category</Heading>
      <Input
        value={categoryName}
        onChange={(e) => setCategoryName(e.target.value)}
        placeholder="Category Name"
        mb={4}
      />
      <Button onClick={handleSaveCategory} colorScheme="blue">Save Category</Button>
    </Box>
  );
};

export default ModifyCategory;
